import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { inject, observer } from 'mobx-react'
import { Layout, Select, Row, Col, Input } from 'antd'

import TermsList from './TermsList'

@inject((store: any) => {
    const { synonymsStore } = store
    return { synonymsStore }
})
@observer
class Terms extends Component<any, any> {
    handleDataChange = async e => {
        const { getTermsList } = this.props.synonymsStore
        await getTermsList(e)
    }
    render() {
        const { addTermFilter, termsFilters } = this.props.synonymsStore
        return (
            <Layout style={{ padding: '0 0.5rem', backgroundColor: 'white' }}>
                <Row gutter={10}>
                    <Col>
                        <Select
                            onChange={e => this.handleDataChange(e)}
                            style={{ width: '100%', padding: '0' }}
                            placeholder="בחר תחום לתצוגת הנתונים"
                        >
                            <Select.Option key="collection_servicefields" value="servicefields">
                                זכויות - תחומים
                            </Select.Option>
                            <Select.Option key="collection_categories" value="categories">
                                זכויות - קטגוריות
                            </Select.Option>
                            <Select.Option key="collection_names" value="collections">
                                זכויות - שמות
                            </Select.Option>
                            <Select.Option key="clinic_types" value="clinic_types">
                                מרפאות - סוגים
                            </Select.Option>
                            <Select.Option key="clinic_services" value="clinic_services">
                                מרפאות - שירותים
                            </Select.Option>
                            <Select.Option key="doctor_specialties" value="specialities">
                                רופאים - התמחויות
                            </Select.Option>
                            <Select.Option key="docotor_specializations" value="specializations">
                                רופאים - התמקצעויות
                            </Select.Option>
                        </Select>
                    </Col>
                </Row>
                <Row style={{ marginTop: '0.4rem' }} gutter={5}>
                    <Col xs={12}>
                        <Input.Search
                            onChange={e => addTermFilter('freeSearch', e.target.value)}
                            value={termsFilters['freeSearch']}
                            placeholder="חפש מושג"
                        />
                    </Col>
                    <Col xs={12}>
                        <Select
                            value={termsFilters['keywords']}
                            placeholder="סנן מושגים"
                            onChange={e => addTermFilter('keywords', e)}
                            style={{ width: '100%' }}
                        >
                            <Select.Option key="allkeywords" value={null}>
                                הצג את כל המושגים
                            </Select.Option>
                            <Select.Option key="assigned" value="assigned">
                                הצג מושגים מוגדרים
                            </Select.Option>
                            <Select.Option key="unassigned" value="unassigned">
                                הצג מושגים לא מוגדרים
                            </Select.Option>
                            <Select.Option key="pending" value="pending">
                                הצג מושגים ממתינים להגדרה
                            </Select.Option>
                        </Select>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <TermsList />
                    </Col>
                </Row>
            </Layout>
        )
    }
}

export default withRouter(Terms)
